import React from 'react'

function Loader() {
  return (
    <div className="loading-component">
    <div className="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
    <h2 className="h4">LOADING...</h2>
    </div>
  )
}

export default Loader